import { API_JWT_BASE_URL } from '../http'

export const GET_FILE_API = `${API_JWT_BASE_URL}/Files/`
export const GET_MULTIPLE_FILES_API = `${API_JWT_BASE_URL}/Files/getmultiplefiles`

export const FILES_QUERY_KEYS = {
  GET_FILE: 'GET_FILE',
  GET_MULTIPLE_FILES: 'GET_MULTIPLE_FILES'
}
